import React, { startTransition, useState } from "react";

import SubMenu from "./SubMenu";
import { logout } from "../../slice/authSlice";
import { useAppDispatch, useAppSelector } from "../../hook";
import { useLocation, useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import { logoutUser } from "../../../common/api/authApi";
import { useTranslation } from "react-i18next";
import { normalizedLocale } from "../../../common/libs/normalizedLocale";
import { deleteRoleState } from "../../slice/roleMatrix";
import { roleMatrix } from './../../slice/roleMatrix';


function SideNavbar() {
  const [open, setOpen] = useState(true);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const locale = normalizedLocale(i18n.language);
  const roleMatrix = useAppSelector(state => state.roleMatrix);
  const userData = useAppSelector(state => state.auth.userData)
  const userDataRole = userData.roles[0]?.name
  const Menus = [
    {
      title: t("Главная страница"),
      icon: "/icons/home.svg",
      route: "/main",
      roleId: 1,
    },
    {
      title: t("Каталог"),
      icon: "/icons/document.svg",
      route: "/organization",
      roleId: 1,
    },
    {
      title: t("Заявки"),
      icon: "/icons/document.svg",
      route: "/orders",
      roleId: 11,
    },
    {
      title: t("Торговые точки"),
      icon: "/icons/store.svg",
      route: "/tradePoints",
      roleId: 1,
      showForAdmin: true,
    },
    // {
    //   title:t("Уведомления"),
    //   icon: "/icons/productCatalog.svg",
    //   route: "/notifications",
    //   roleId:13,
    // },
    // {
    //   title:t("Импорт"),
    //   icon: "/icons/productCatalog.svg",
    //   route: "/import",
    //   roleId:13,
    // }
    // { title: t("submenu.reports"), icon: "/icons/piechart.svg", route: "" },
  ];

  const Logout = { title: t("submenu.logout"), icon: "/icons/exit.svg" };

  // Функция для выхода пользователя
  const handleLogout = async () => {
    const refreshToken = Cookies.get("refresh_token");
    console.log(refreshToken);
    if (refreshToken) {
      try {
        await logoutUser(refreshToken);
        dispatch(deleteRoleState);
        dispatch(logout());
        navigate("/auth");
      } catch (error) {
        dispatch(deleteRoleState);
        dispatch(logout());
        navigate('/auth');
      }
    } else {
      // Если refreshToken не найден, просто диспатчим действие logout
      dispatch(deleteRoleState);
      dispatch(logout());
      navigate("/auth");
    }
  };

  return (
    <nav
      className={` ${open ? "w-72" : "w-20 "
        } overflow-hidden bg-white  p-5  pt-8 relative duration-300 rounded shadow-md h-full flex flex-col`}
    >
      <div className="flex flex-row items-center justify-between"><div></div>
        <div className="flex gap-x-4 items-center">

          <img
            src={`/icons/articool.svg`}
            alt="E-Track Logo"
            className={`hover:scale-110 items-center h-12 origin-left font-medium text-xl duration-200 ${!open && "scale-0"
              }`}
              onClick={() => window.open('https://new3.articool.online/products', '_blank')}

          />
        </div>
        <img
          src="/icons/double-arrow-left.svg"
          className={`cursor-pointer  p-1 w-7 h-7 bg-slate-300
         rounded-full  ${!open && "rotate-180"}`}
          onClick={() => setOpen(!open)}
        />
      </div>

      <ul className="pt-6 h-full m-0 flex flex-col ">
        <li className=" pb-[10px] border-b border-gray-200 ">
          {Menus.map((menu: any, index) => {
            const menuRole = roleMatrix.roleMatrix.find(area => menu.roleId === area.id);
            const shouldShowMenuItem = menu.showForAdmin 
              ? userDataRole === 'Администратор' 
              : true || menuRole && menuRole.view;
            
            if (shouldShowMenuItem) {
              return (
                <SubMenu
                  key={`submenu-${index}-0-${menu.title}`}
                  index={index}
                  icon={menu.icon}
                  title={menu.title}
                  route={menu.route || ""}
                  open={open}
                  subMenuItems={menu.SubMenuItems?.filter((subMenu: any) => {
                    const subMenuRole = roleMatrix.roleMatrix.find(area => subMenu.roleId === area.id);
                    return true || subMenuRole && subMenuRole.view;
                  })}
                />
              );
            }
            return null;
          })}

        </li>
        {/* <button
            key={`meni-item-logout`}
            className="w-full group flex rounded-md p-2 cursor-pointer hover:bg-light-white items-center gap-x-4 mt-2 
              hover:bg-mainColor hover:text-white"
            onClick={()=>navigate('/settings')}
          >
            <img
              src={Logout.icon}
              className="block h-6 w-6 duration-200 group-hover:brightness-200 group-hover:invert-1"
            />
            <span className={`${!open && "hidden"} origin-left duration-200`}>
              Настройки
            </span>
          </button> */}
        <li className="mt-auto">
          <button
            key="meni-item-logout"
            className="w-full group flex rounded-md p-2 cursor-pointer hover:bg-light-white items-center gap-x-4 mt-2 bg-slate-100
    hover:bg-mainColor hover:text-gray-700"
            onClick={() => {
              Cookies.remove("role");
              Cookies.remove("name");

              startTransition(() => {
                navigate("/auth");
              });
            }}
          >
            <img
              src={Logout.icon}
              className="block h-6 w-6 duration-200  group-hover:invert-1"
            />
            <span className={`${!open && "hidden"} origin-left duration-200`}>
              {Logout.title}
            </span>
          </button>
        </li>
      </ul>
    </nav>
  );
}

export default SideNavbar;
